module.exports = __webpack_public_path__ + "static/carbon-fiber-68aa525f040484bde88163cde36adaae.jpg";